<template>
  <Layout>
    <main>
      <section>
        <page-header
          :colorFont="colorFontBody"
          :fontDetail="fontDetailBody"
          :tableNumber="tableNumber"
          hasBackButton
          @back="handleBack"
        >
          <page-indicator
            :colorPrimary="colorPrimary"
            :colorSecondary="colorSecondary"
            :index="0"
          />
        </page-header>
      </section>
      <section :class="$style['body']">
        <h1
          v-if="billTitle"
          :class="$style['body-title']"
          v-text="billTitle"
          v-color="colorFontHeading"
          v-font-style="fontDetailHeading"
        />
        <p
          v-if="billBodyText"
          v-text="billBodyText"
          v-color="colorFontBody"
          v-font-style="fontDetailBody"
        />
        <bill-items
          v-if="billItems"
          :colorFontBody="colorFontBody"
          :fontBody="fontDetailBody"
          :items="billItems"
        />
      </section>
      <section :class="$style['footer']" v-background-color="colorBackground">
        <v-button
          @buttonClick="handleButtonClick"
          hasContainer
          :buttonText="billButtonText"
          :billTotal="totalIncludingDiscount"
          :billQuantity="billQuantity"
          :colorButton="colorPrimary"
          :colorButtonText="colorFontButton"
          :fontButton="fontDetailButton"
          :fontButtonSecondary="fontDetailBody"
        />
      </section>
    </main>

    <modal-wrapper v-if="showTransactionModal">
      <modal-transaction />
    </modal-wrapper>
  </Layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash.get'
import appConfig from '@src/app.config'
import BillItems from '@components/bill-items.vue'
import Layout from '@layouts/main.vue'
import ModalTransaction from '@components/modal-transaction.vue'
import ModalWrapper from '@components/modal-wrapper.vue'
import PageHeader from '@components/page-header.vue'
import PageIndicator from '@components/page-indicator.vue'
import VButton from '@components/v-button.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    BillItems,
    Layout,
    ModalTransaction,
    ModalWrapper,
    PageHeader,
    PageIndicator,
    VButton,
  },
  computed: {
    ...mapGetters('contentful', [
      'billBodyText',
      'billButtonText',
      'billTitle',
      'colorBackground',
      'colorFontBody',
      'colorFontButton',
      'colorFontHeading',
      'colorPrimary',
      'colorSecondary',
      'contentfulLoadingStatus',
      'fontDetailHeading',
      'fontDetailBody',
      'fontDetailButton',
      'locations',
      'logo',
    ]),
    ...mapGetters('payment', [
      'billItems',
      'billQuantity',
      'location',
      'tableNumber',
      'totalIncludingDiscount',
    ]),
    ...mapGetters('ui', ['showTransactionModal']),
  },
  methods: {
    ...mapActions('payment', [
      'getBasketAndHandleResponse',
      'resetPaymentData',
      'setLocation',
      'setTableNumber',
    ]),
    ...mapActions('ui', ['setPageLoadingStatus', 'toggleTransactionModal']),
    handleButtonClick() {
      this.toggleTransactionModal({ modalIsVisible: true })
    },
    handleBack() {
      const slug = get(this.location, 'fields.slug')
      if (slug) {
        this.setPageLoadingStatus('loading')
        this.$router.push({ path: `/${slug}` })
      }
    },
    getLocationFromSlug() {
      const pageSlug = get(this.$route, 'params.slug')
      return this.locations.find((location) => {
        const locationSlug = get(location, 'fields.slug')
        return locationSlug === pageSlug
      })
    },
    async init() {
      this.setPageLoadingStatus('loading')
      this.resetPaymentData()

      const location = this.getLocationFromSlug()
      if (!location) {
        return this.$router.replace({ path: '/404' })
      }

      await this.setLocation(location)

      // TODO: Check location enabled

      const tableNumber = get(this.$route, 'params.id')
      // TODO: validate tableNumber with a regex
      await this.setTableNumber(tableNumber)

      try {
        await this.getBasketAndHandleResponse()
      } catch (err) {
        console.log('view err: ', err)
      }

      this.setPageLoadingStatus('loaded')
    },
  },
  watch: {
    contentfulLoadingStatus(newVal) {
      if (newVal === 'loaded') {
        this.init()
      }
    },
  },
  created() {
    if (this.contentfulLoadingStatus === 'loaded') {
      this.init()
    }
  },
}
</script>

<style lang="scss" module>
@import '@design';

.body {
  padding: 0 16px;
  padding-bottom: 64px;

  .body-title {
    padding-top: 16px;
  }
}

.footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}
</style>
